export type breakpointsType = {
  s: number;
  m: number;
  l: number;
  xl: number;
  xxl: number;
};

export const Breakpoints: breakpointsType = {
  s: 568,
  m: 768,
  l: 992,
  xl: 1024,
  xxl: 1440,
};

export const useBreakpoint = (breakpoint: keyof breakpointsType) => `@media (min-width: ${Breakpoints[breakpoint]}px)`;
